module.exports = __webpack_public_path__ + "static/media/noun-where-to-go-2.43136269.svg";